import { I18n } from 'src/i18n/I18n'
import { Button, Link } from 'src/ui-components'
import styled from 'styled-components'
import Stages from './Stages/components/Stages'
import { Hyperlink } from 'src/ui-components/util/Hyperlink'
import { ReactElement } from 'react'
import { defaultTheme } from 'src/theme'
import { useAddToListStore } from 'src/store/lists/AddToListStore'
import { CofirmationModal } from 'src/ui-components/modals/ConfirmationModal'
import { show as showNiceModal } from '@ebay/nice-modal-react'
import { Translate } from '../../../../i18n'

interface Props {
  title?: string
  showStages: boolean
  goBack?: Link
  goNext?: Link
  children: ReactElement
  disableNextButton?: boolean
}

const DEFAULT_TITLE = 'addItems'

const Wizard = (props: Props): ReactElement => {
  const { title, showStages, goBack, goNext, children, disableNextButton } =
    props
  const addToListStore = useAddToListStore()

  const msg = `${Translate('itemsWillNotBeAddedToList')}.`

  const handleCancel = () => {
    showNiceModal(CofirmationModal, {
      title: 'cancelAddingItems', // Cancel Adding Items
      primaryActionText: 'cancel',
      secondaryActionText: 'continueWorking',
      primaryButtonVariant: 'danger',
      children: msg,
    }).then((data) => {
      if (data) {
        addToListStore.reset()
      }
    })
  }

  return (
    <Wrapper>
      <Header>
        <SpaceBetween>
          <div>
            <Title>
              <I18n name={title} />
            </Title>
            {showStages && <Stages />}
          </div>
          <div className="my-auto">
            <Hyperlink
              action={handleCancel}
              color={defaultTheme.colors.almostBlack}
            >
              <I18n name="cancel" />
            </Hyperlink>
          </div>
        </SpaceBetween>
      </Header>
      <Separator />
      <Body>{children}</Body>
      {!!goBack && !!goNext && (
        <>
          <Separator />
          <Footer>
            <SpaceBetween>
              <Button
                text={goBack.text}
                variant="secondary"
                onClick={goBack.action}
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
                disabled={goBack.enabled == false} // Given the enabled attribute is optional then check if it's false
              />
              <Button
                text={goNext.text}
                variant={'primary'}
                onClick={goNext.action}
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-boolean-literal-compare
                disabled={goNext.enabled == false || disableNextButton} // Given the enabled attribute is optional then check if it's false
              />
            </SpaceBetween>
          </Footer>
        </>
      )}
    </Wrapper>
  )
}

Wizard.defaultProps = {
  title: DEFAULT_TITLE,
  showStages: true,
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`

const BaseSection = styled.div`
  width: 100%;
  padding: 0.5rem 5rem 0.5rem 5rem;
`

const Header = styled(BaseSection)`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`

const Body = styled(BaseSection)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

const Footer = styled(BaseSection)`
  display: flex;
  flex-direction: row;
`

const Title = styled.div`
  font-family: Oswald;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  text-align: left;
`

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const Separator = styled.hr``

export default Wizard
